import { render, staticRenderFns } from "./CertificateSection.vue?vue&type=template&id=dcfad7ac&scoped=true"
import script from "./CertificateSection.vue?vue&type=script&lang=js"
export * from "./CertificateSection.vue?vue&type=script&lang=js"
import style0 from "./CertificateSection.vue?vue&type=style&index=0&id=dcfad7ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfad7ac",
  null
  
)

export default component.exports